import ky from "ky";

class HTTPError extends Error {
  constructor(message, status, body = null) {
    super(message);
    this.name = "HTTPError";
    this.status = status;
    this.body = body;
  }
}

const clientAuth = ky.extend({
  prefixUrl: `${process.env.REACT_APP_IMAGE_URL}api/`,
  timeout: false,

  hooks: {
    beforeRequest: [
      (request) => {
        let token = localStorage.getItem("usertoken");

        // ✅ if token saved as JSON string, remove quotes safely
        if (token) token = token.replace(/^"|"$/g, "");

        if (token) request.headers.set("Authorization", `Bearer ${token}`);
      },
    ],

    afterResponse: [
      async (request, options, response) => {
        if (!response.ok) {
          let message = "Something went wrong";
          let body = null;

          try {
            body = await response.clone().json();
            message = body?.message || message;
          } catch {}

          if (response.status === 401) {
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/login";
          }

          throw new HTTPError(message, response.status, body);
        }
      },
    ],
  },
});

export default clientAuth;
